(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lithink-tutorial-videos"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (window.lithinkTutorialPlaybackV3) return;
  window.lithinkTutorialPlaybackV3 = true;
  let activeVideo = null;

  function prepareDialog(dialog) {
    if (!dialog || dialog.dataset.ltPrepared) return;
    dialog.dataset.ltPrepared = 'true';
    dialog.addEventListener('close', () => {
      if (dialog.open || !dialog.isConnected) return;
      dialog.classList.remove('is-expanded');
      dialog.show();
      const card = dialog.closest('.lt-tutorials__card');
      const expand = card && card.querySelector('[data-lt-enlarge]');
      if (expand) expand.focus();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog || !dialog.classList.contains('is-expanded')) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
  }

  function initialise(root) {
    root.querySelectorAll('.lt-tutorials__card').forEach((card) => {
      const video = card.querySelector('[data-lt-video]');
      const poster = card.querySelector('[data-lt-playback]');
      const dialog = card.querySelector('[data-lt-player]');
      prepareDialog(dialog);
      if (!video || !poster || video.dataset.ltPrepared) return;
      video.dataset.ltPrepared = 'true';
      poster.hidden = false;
      video.addEventListener('play', () => {
        poster.hidden = true;
        if (activeVideo && activeVideo !== video) activeVideo.pause();
        activeVideo = video;
      });
      video.addEventListener('ended', () => { poster.hidden = false; });
      video.addEventListener('error', () => { poster.hidden = true; });
    });
  }

  function playVideo(video, poster) {
    if (activeVideo && activeVideo !== video) activeVideo.pause();
    activeVideo = video;
    if (poster) poster.hidden = true;
    const result = video.play();
    if (result && typeof result.catch === 'function') {
      result.catch(() => {
        // Keep native controls accessible when a browser rejects play().
        if (poster) poster.hidden = true;
      });
    }
  }

  function externalPlayer(card, poster) {
    let dialog = card.querySelector('[data-lt-player]');
    if (dialog) return dialog;
    const id = poster && poster.dataset.videoId;
    if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return null;
    dialog = document.createElement('dialog');
    dialog.className = 'lt-tutorials__player';
    dialog.dataset.ltPlayer = '';
    dialog.setAttribute('aria-label', poster.dataset.videoTitle);
    const bar = document.createElement('div');
    bar.className = 'lt-tutorials__player-bar';
    const close = document.createElement('button');
    close.type = 'button';
    close.dataset.ltDismiss = '';
    close.className = 'lt-tutorials__player-close';
    const expand = card.querySelector('[data-lt-enlarge]');
    close.textContent = (expand && expand.dataset.closeLabel) || 'Close';
    bar.append(close);
    const frame = document.createElement('div');
    frame.className = 'lt-tutorials__player-frame';
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1&fs=0';
    iframe.title = poster.dataset.videoTitle;
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.append(iframe);
    dialog.append(bar, frame);
    card.querySelector('[data-lt-media]').append(dialog);
    prepareDialog(dialog);
    dialog.show();
    poster.hidden = true;
    return dialog;
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const close = target.closest('[data-lt-dismiss]');
    if (close) {
      event.preventDefault();
      event.stopPropagation();
      const dialog = close.closest('[data-lt-player]');
      if (dialog) dialog.close();
      return;
    }
    const play = target.closest('[data-lt-playback]');
    const enlarge = target.closest('[data-lt-enlarge]');
    if (!play && !enlarge) return;
    const card = (play || enlarge).closest('.lt-tutorials__card');
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    initialise(card.parentElement);
    const poster = card.querySelector('[data-lt-playback]');
    const video = card.querySelector('[data-lt-video]');
    const dialog = video ? card.querySelector('[data-lt-player]') : externalPlayer(card, poster);
    if (!dialog) return;
    if (video && (play || video.paused)) playVideo(video, poster);
    if (enlarge && !dialog.classList.contains('is-expanded')) {
      prepareDialog(dialog);
      dialog.close();
      dialog.classList.add('is-expanded');
      try {
        dialog.showModal();
      } catch (error) {
        dialog.classList.remove('is-expanded');
        if (!dialog.open) dialog.show();
      }
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-lt-video]').forEach((video) => video.pause());
    if (activeVideo && event.target.contains(activeVideo)) activeVideo = null;
  });
})();


  } catch(e) { console.error(e); }
})();
})();
